"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemUser = void 0;
var SystemUser = /** @class */ (function () {
    function SystemUser() {
    }
    return SystemUser;
}());
exports.SystemUser = SystemUser;
//# sourceMappingURL=SystemUser.js.map